<template>
	<CompanyList :includeSuppliers="true" />
</template>
<script lang="ts">
	import { Vue, Options } from 'vue-class-component';
	import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';

	Vue.registerHooks([
		'beforeRouteEnter',
	]);

	// This module is implemented as a separate module, so that keep-alive will keep it with its own filter (not shared between suppliers, customers, owners, but as independent filters)
	@Options({
		name: "SupplierList",
	})
	export default class SupplierList extends Vue {
		// Event each time accessing this page
		  beforeRouteEnter(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
			next((vm: Vue) => {
				// ensure company list downloaded
				vm.$store.dispatch('downloadCompanyList');
			})
		}
	}
</script>